import intervalUntilExists from "./intervalUntilExists";
/**
 * Calls handler once resolved
 * @param {string} selector
 * @param {function} handler
 */
const onContentChange = (selector, handler, pageDocument : Document | ShadowRoot = document) => {
  intervalUntilExists(selector, () => {
    let oldContent = pageDocument.querySelector(selector)?.textContent;

    setInterval(function () {
      let currentContent = pageDocument.querySelector(selector)?.textContent;
      if (oldContent !== currentContent) {
        oldContent = currentContent;
        handler();
      }
    }, 500);
  },
  undefined,
  pageDocument
);
};

export default onContentChange;
